import React, { useState, useEffect, useRef } from 'react';
import '../styles/SmartAppBanner.scss';

const SmartAppBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [platform, setPlatform] = useState(null);
  const bannerRef = useRef(null);

  useEffect(() => {
    const dismissed = localStorage.getItem('dismissedAppBanner');
    if (dismissed === 'true') return;

    const ua = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/i.test(ua) && !window.MSStream) {
      setPlatform('ios');
      setIsVisible(true);
    } else if (/android/i.test(ua)) {
      setPlatform('android');
      setIsVisible(true);
    }
    // Desktop → no banner
  }, []);

  // Update CSS variable when banner visibility or height changes
  useEffect(() => {
    if (isVisible && bannerRef.current) {
      const height = bannerRef.current.offsetHeight;
      document.documentElement.style.setProperty('--smart-app-banner-height', `${height}px`);
    } else {
      document.documentElement.style.setProperty('--smart-app-banner-height', '0px');
    }

    return () => {
      document.documentElement.style.setProperty('--smart-app-banner-height', '0px');
    };
  }, [isVisible]);

  const handlePrimaryAction = () => {
    // Let backend + OS handle everything
    window.location.href = 'https://invits.co/app';
  };

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('dismissedAppBanner', 'true');
    document.documentElement.style.setProperty('--smart-app-banner-height', '0px');
  };

  if (!isVisible || !platform) return null;

  return (
    <div className="smart-app-banner" ref={bannerRef}>
      <div className="smart-app-banner__content">
        <div className="smart-app-banner__icon">
          <img src="/icon.png" alt="Invits" />
        </div>

        <div className="smart-app-banner__text">
          <h4>Invits</h4>
          <p>Open the app for the best experience</p>
        </div>

        <div className="smart-app-banner__actions">
          <button
            className="smart-app-banner__btn smart-app-banner__btn--primary"
            onClick={handlePrimaryAction}
          >
            Open App
          </button>

          <button
            className="smart-app-banner__btn smart-app-banner__btn--close"
            onClick={handleClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmartAppBanner;
